import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-2283">
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-2284">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-2285" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-2286" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-2287">
        <div className="flex gap-8" data-id="element-2288">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-2289">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-2290" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2291">
        <div className="space-y-6" data-id="element-2292">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2293">
            <div data-id="element-2294">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-2295" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-2296" />
            </div>
            <div data-id="element-2297">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-2298" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-2299" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-2300">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-2301" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-2302" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2303">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-2304">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-2305" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-2306" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-2307">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-2308" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-2309" />
      </div>
    </div>;
}